import { isConfigReport, isRelationalReport } from 'reporting-data/tsTypes/reportTypes';
import useFetchUserInfo from '../../hooks/useFetchUserInfo';
import ConfigReportDataColumnsModal from './ConfigReportDataColumnsModal';
import RelationalReportDataColumnsModal from './RelationalReportDataColumnsModal';
import { isReportValidForDataColumnsModal } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const DataColumnsModal = props => {
  const {
    report
  } = props;
  const userInfo = useFetchUserInfo();
  if (isReportValidForDataColumnsModal(report, userInfo || {
    gates: [],
    portal: {},
    user: {
      scopes: []
    }
  })) {
    if (isConfigReport(report)) {
      return /*#__PURE__*/_jsx(ConfigReportDataColumnsModal, Object.assign({}, props, {
        report: report
      }));
    } else if (isRelationalReport(report)) {
      return /*#__PURE__*/_jsx(RelationalReportDataColumnsModal, Object.assign({}, props, {
        report: report
      }));
    }
  }
};